// This optional code is used to register a service worker.
// register() is not called by default.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  console.log('[ServiceWorker:Registration]: Register service worker');

  window.ServiceWorker.activeWorkerState = 'unknown';

  if (/* process.env.NODE_ENV === 'production' && */ 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL || window.location.origin, window.location.href);
    console.log('[ServiceWorker:Registration]: publicUrl', publicUrl);
    if (publicUrl.origin !== window.location.origin) {
      console.log('[ServiceWorker:Registration]: origin differs from window.location.origin');
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }
  
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL || window.location.origin}/service-worker.js`;
      console.log('[ServiceWorker:Registration]: onLoad->addEventListener:swUrl', swUrl);

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config); // calls => registerValidSW(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then((registration) => {
          console.log('[ServiceWorker:Registration]: REGISTRATION', registration);

          console.log(
            '[ServiceWorker:Registration]: This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then((registration) => {
          console.log('[ServiceWorker:Registration]: REGISTRATION', registration);

          console.log(
            '[ServiceWorker:Registration]: This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          );
        });
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  console.log('[ServiceWorker:Registration]: registerValidSW', swUrl, config);
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[ServiceWorker:Registration]: registerValidSW->register: ', registration);

      const activeWorker = registration?.active;
      console.log('[ServiceWorker:Registration]: active service worker state', activeWorker?.state);
      if(activeWorker?.state === 'activated') {
        console.log('[ServiceWorker:Registration]: SERVICE_WORKER_READY');
        window.ServiceWorker.activeWorkerState = 'ready';
      }

      // Service Worker updates
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                '[ServiceWorker:Registration]: New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://cra.link/PWA.'
              );
              
              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('[ServiceWorker:Registration]: Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          } else if (installingWorker.state === 'activated') {
            console.log('[ServiceWorker:Registration]: ACTIVATED');
            window.ServiceWorker.activeWorkerState = 'activated';
          }
        };
      };
    })
    .catch((error) => {
      console.error('[ServiceWorker:Registration]: Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  console.log('[ServiceWorker:Registration]: checkValidServiceWorker', swUrl, config);
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      console.log('[ServiceWorker:Registration]: checkValidServiceWorker: response', response);
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      console.log('[ServiceWorker:Registration]: checkValidServiceWorker: contentType', contentType);
      
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        console.log('[ServiceWorker:Registration]: checkValidServiceWorker: No service worker found!');
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          console.log('[ServiceWorker:Registration]: checkValidServiceWorker: Unregister service worker!');
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        console.log('[ServiceWorker:Registration]: checkValidServiceWorker: registerValidSw');
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('[ServiceWorker:Registration]: No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[ServiceWorker:Registration]:', error.message);
      });
  }
}
